// 45be085d06f2b331b038fb65c016444f3a7ecebd|kind=api-js|className=CountryApi|type=angular|apiName=entity|apiEnumKey=Entity|operationHash=acfe31feff1c4aae061f2c27a0e475ffc288250f

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';

import { parseOkResponseWrappingCountryListFromJSON } from '../../../parsers/OkResponseWrappingCountryList';

export class CountryApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags CountryApi
   * @name CountryApiGetCountries
   * @summary Get all countries
   * @request GET:/countries
   */
  getCountries(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/countries`,
        method: 'GET',
        api: Api.Entity,
      },
      {
        ...requestOptions,
        parser: parseOkResponseWrappingCountryListFromJSON,
      },
    );
  }

  static ɵfac = function CountryApi_Factory(t) { return new (t || CountryApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CountryApi, factory: CountryApi.ɵfac, providedIn: 'root' });
}
